import { ApiResponse, http } from '@config/api';
import { Dictionary } from '@utils/util.types';

export async function fetchIrrigation(): Promise<Dictionary[]> {
	const response = await http.get<ApiResponse<Dictionary[]>>('irrigation-types', 'list/');

	return response.data.data;
}
